import axios from 'axios';

export function getAddTask(projectUserId) {
  return axios.get(`/project/${projectUserId}/task/add`);
}

export function postAddTask(projectUserId, payload) {
  return axios.post(`/project/${projectUserId}/task/add`, payload);
}

export function getConfirmTask(projectUserId, taskId) {
  return axios.get(`/project/${projectUserId}/task/${taskId}/confirm`);
}

export function postConfirmTask(projectUserId, taskId) {
  return axios.post(`/project/${projectUserId}/task/${taskId}/confirm`);
}

export function confirmAll(projectUserId, payload) {
  return axios.post(`/project/${projectUserId}/task/confirm-all`, payload);
}

export function changeAll(projectUserId, payload) {
  return axios.post(`/project/${projectUserId}/task/change-all`, payload);
}

export function updateAll(projectUserId, payload) {
  return axios.post(`/project/${projectUserId}/task/update-all`, payload);
}

export function deleteTask(projectUserId, taskId) {
  return axios.delete(`/project/${projectUserId}/task/${taskId}`);
}